export var AutoCastPolicy;!function(o){o[o.ALWAYS=0]="ALWAYS",o[o.WHEN_IDLE=1]="WHEN_IDLE",o[o.NEVER=2]="NEVER"}(AutoCastPolicy||(AutoCastPolicy={}));